import { render, staticRenderFns } from "./MerchandisingDisplay.vue?vue&type=template&id=ed41980a"
import script from "./MerchandisingDisplay.vue?vue&type=script&lang=js"
export * from "./MerchandisingDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports